/* eslint-disable react/no-danger */
import React, { useState } from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// ANT DESIGN COMPONENTS
import { Button, Tooltip } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
import FormInputNumber from "../../../../../components/form/FormInputNumber";
// INTERFACES
import {
  GetServerListResponseInterface,
  GuidInterface,
} from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentGetServerListResponse({
  data,
  setData,
}: {
  data: GetServerListResponseInterface;
  setData: (newValue: GetServerListResponseInterface) => void;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [nameList, setNameList] = useState<string>("");
  const [classList, setClassList] = useState<GuidInterface>({
    data_4: [],
    data_1: 0,
    data_2: 0,
    data_3: 0,
  });

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickAddNewNameList = () => {
    const copy = structuredClone(data);
    copy.name_list.push(nameList);
    setData(copy);
    setNameList("");
  };

  const onClickRemoveNameList = (index: number) => {
    const copy = structuredClone(data);
    copy.name_list.splice(index, 1);
    setData(copy);
  };

  const onClickAddNewClassList = () => {
    const copy = structuredClone(data);
    copy.class_id_list.push(classList);
    setClassList({
      data_4: [],
      data_1: 0,
      data_2: 0,
      data_3: 0,
    });
    setData(copy);
  };

  const onClickRemoveClassList = (index: number) => {
    const copy = structuredClone(data);
    copy.class_id_list.splice(index, 1);
    setData(copy);
  };

  const formatJsonWithColors = (obj: any) => {
    const json = JSON.stringify(obj, null, 4)
      .replace(/"([^"]+)"\s*:/g, '<span style="color:#9cdcfe;">"$1"</span>:')
      .replace(/: "([^"]*)"/g, ': <span style="color:#ce9178;">"$1"</span>')
      .replace(/:\s*(\d+)/g, ': <span style="color:#b5cea8;">$1</span>');
    return json;
  };

  const onChangeValueNameList = (newValue: string) => {
    setNameList(newValue);
  };

  const onChangeValueClassList = (newValue: number, variableName: string) => {
    const copy = structuredClone(classList);
    if (variableName === "data_1") {
      copy.data_1 = newValue;
    }
    setClassList(copy);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <FormInputText
        inputValue={nameList}
        inputLabelName={t("general.itemName")}
        inputOnChange={onChangeValueNameList}
        inputVariableName="item_name"
        isRequired
        disabledInput={false}
      />
      <div className="col-md-12 mt-3">
        <div className="generalStyles__flex">
          <div className="generalStyles__inputFlexNameLarge">
            <span className="generalStyles__inputFlexRequired">*</span>
            <span className="drawer__text">{t("general.nameList")}</span>
          </div>
          <div className="generalStyles__width100">
            {data.name_list.map((item: string, itemIndex: number) => (
              <div
                key={itemIndex}
                className="mb-3"
                style={{
                  backgroundColor: "#1f1f1f",
                  borderRadius: "5px",
                  fontSize: "9px",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <pre
                    style={{
                      width: "100%",
                      color: "#dcdcdc",
                      padding: "10px",
                      borderRadius: "8px",
                      overflowX: "auto",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: formatJsonWithColors(item),
                    }}
                  />
                  <div className="generalStyles__flexCenter">
                    <Tooltip title={t("general.delete")}>
                      <Button
                        onClick={() => {
                          onClickRemoveNameList(itemIndex);
                        }}
                        className="buttonStyle__29"
                        shape="circle"
                        icon={<FontAwesomeIcon icon={faTrash} />}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="generalStyles__infoTooltipIconBlank" />
        </div>
      </div>
      <div className="col-md-12 mt-3">
        <div className="generalStyles__flex">
          <div className="generalStyles__inputFlexNameLarge">
            <span className="generalStyles__inputFlexRequired" />
          </div>
          <div className="generalStyles__width100">
            <Button
              onClick={onClickAddNewNameList}
              className="buttonStyle__28 generalStyles__width100"
            >
              <FontAwesomeIcon icon={faPlus} className="generalStyles__mrFix" />
              {t("general.add")}
            </Button>
          </div>
          <div className="generalStyles__infoTooltipIconBlank" />
        </div>
      </div>

      <FormInputNumber
        inputValue={classList.data_1}
        inputLabelName="Data 1"
        inputOnChange={onChangeValueClassList}
        inputVariableName="data_1"
      />
      <FormInputNumber
        inputValue={classList.data_2}
        inputLabelName="Data 2"
        inputOnChange={onChangeValueClassList}
        inputVariableName="data_2"
      />
      <FormInputNumber
        inputValue={classList.data_3}
        inputLabelName="Data 3"
        inputOnChange={onChangeValueClassList}
        inputVariableName="data_3"
      />

      <div className="col-md-12 mt-3">
        <div className="generalStyles__flex">
          <div className="generalStyles__inputFlexNameLarge">
            <span className="generalStyles__inputFlexRequired">*</span>
            <span className="drawer__text">{t("general.classList")}</span>
          </div>
          <div className="generalStyles__width100">
            {data.class_id_list.map((item: GuidInterface, itemIndex: number) => (
              <div
                key={itemIndex}
                className="mb-3"
                style={{
                  backgroundColor: "#1f1f1f",
                  borderRadius: "5px",
                  fontSize: "9px",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <pre
                    style={{
                      width: "100%",
                      color: "#dcdcdc",
                      padding: "10px",
                      borderRadius: "8px",
                      overflowX: "auto",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: formatJsonWithColors(item),
                    }}
                  />
                  <div className="generalStyles__flexCenter">
                    <Tooltip title={t("general.delete")}>
                      <Button
                        onClick={() => {
                          onClickRemoveClassList(itemIndex);
                        }}
                        className="buttonStyle__29"
                        shape="circle"
                        icon={<FontAwesomeIcon icon={faTrash} />}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="generalStyles__infoTooltipIconBlank" />
        </div>
      </div>
      <div className="col-md-12 mt-3">
        <div className="generalStyles__flex">
          <div className="generalStyles__inputFlexNameLarge">
            <span className="generalStyles__inputFlexRequired" />
          </div>
          <div className="generalStyles__width100">
            <Button
              onClick={onClickAddNewClassList}
              className="buttonStyle__28 generalStyles__width100"
            >
              <FontAwesomeIcon icon={faPlus} className="generalStyles__mrFix" />
              {t("general.add")}
            </Button>
          </div>
          <div className="generalStyles__infoTooltipIconBlank" />
        </div>
      </div>
    </div>
  );
}
